import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Lagerstand } from './Lagerstand';

export const LagerstandPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const artikelGruppeNrList = (urlSearchParams.get('artikelGruppeNrList') || '')
        .split(',')
        .map((s) => parseInt(s, 10))
        .filter((n) => !!n);

    const lagerIntNrList = (urlSearchParams.get('lagerIntNrList') || '')
        .split(',')
        .map((s) => parseInt(s, 10))
        .filter((n) => !!n);

    const minBestandVon = parseFloat(urlSearchParams.get('minBestandVon') || '0') || 0;
    const bestandVon = parseFloat(urlSearchParams.get('bestandVon') || '0') || 0;
    const offenBestVon = parseFloat(urlSearchParams.get('offenBestVon') || '0') || 0;
    const offenBestVonD = parseFloat(urlSearchParams.get('offenBestVonD') || '0') || 0;
    const offenLiefVon = parseFloat(urlSearchParams.get('offenLiefVon') || '0') || 0;
    const offenLiefVonD = parseFloat(urlSearchParams.get('offenLiefVonD') || '0') || 0;
    const offenResVon = parseFloat(urlSearchParams.get('offenResVon') || '0') || 0;

    const includeArchiv = urlSearchParams.get('includeArchiv') === 'true';
    const showOffenBest = urlSearchParams.get('showOffenBest') === 'true';
    const showOffenLief = urlSearchParams.get('showOffenLief') === 'true';
    const showLagerwert = urlSearchParams.get('showLagerwert') === 'true';

    const bestandBelowMinBestand = urlSearchParams.get('bestandBelowMinBestand') === 'true';
    const verfuegbarBelowMinBestand = urlSearchParams.get('verfuegbarBelowMinBestand') === 'true';

    return (
        <Lagerstand
            artikelGruppeNrList={artikelGruppeNrList}
            lagerIntNrList={lagerIntNrList || []}
            minBestandVon={minBestandVon}
            bestandBelowMinBestand={bestandBelowMinBestand}
            verfuegbarBelowMinBestand={verfuegbarBelowMinBestand}
            bestandVon={bestandVon}
            offenBestVon={offenBestVon}
            offenBestVonD={offenBestVonD}
            offenLiefVon={offenLiefVon}
            offenLiefVonD={offenLiefVonD}
            offenResVon={offenResVon}
            includeArchiv={includeArchiv}
            showOffenBest={showOffenBest}
            showOffenLief={showOffenLief}
            showLagerwert={showLagerwert}
            printView
        />
    );
};
